import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { HrManagerTeamSummary } from '../../../hr/hr.models';
import { MyHrWorkspaceService } from '../shared/my-hr-workspace.service';
import { labelize, statusSeverity } from '../shared/my-hr-workspace.utils';

@Component({
  selector: 'app-my-hr-team',
  standalone: true,
  imports: [CommonModule, TableModule, TagModule, PageDataPanelComponent],
  templateUrl: './my-hr-team.component.html',
  styleUrls: ['./my-hr-team.component.scss']
})
export class MyHrTeamComponent implements OnInit {
  private readonly workspaceService = inject(MyHrWorkspaceService);

  summary?: HrManagerTeamSummary;

  ngOnInit(): void {
    this.workspaceService.loadManagerSummary().subscribe({
      next: summary => {
        this.summary = summary;
      },
      error: () => {
        this.summary = undefined;
      }
    });
  }

  label(value?: string): string {
    return labelize(value);
  }

  statusSeverity(value?: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' {
    return statusSeverity(value);
  }
}
